import {Language, LocalStorageItem} from '@enums'

import {atom} from 'jotai'
import {atomWithStorage} from 'jotai/utils'

import {CompanyCurrency, UserLanguage, UserSelection, UserTimeFormat} from './types'

export const userPreferencesHydratedAtom = atom(false)

export const languageSelectionAtom = atomWithStorage<UserLanguage[]>(LocalStorageItem.USER_LANGUAGES, [])

export const timeFormatSelectionAtom = atomWithStorage<UserTimeFormat[]>(LocalStorageItem.USER_TIME_FORMATS, [])

export const currencySelectionAtom = atomWithStorage<CompanyCurrency[]>(LocalStorageItem.CURRENCIES, [])

export const userSelectionAtom = atomWithStorage<UserSelection[]>(LocalStorageItem.USER_SELECTIONS, [])

export const getUserSelectionAtom = atom(get => {
  const selections = get(userSelectionAtom)
  return selections.reduce<Record<string, UserSelection>>((acc, sel) => {
    acc[sel.userId] = sel
    return acc
  }, {})
})

export const setUserSelectionAtom = atom(null, (get, set, selection: UserSelection) => {
  const selections = get(userSelectionAtom)

  const next = selections.some(item => item.userId === selection.userId)
    ? selections.map(item => (item.userId === selection.userId ? selection : item))
    : [...selections, selection]

  set(userSelectionAtom, next)
})

export const getUserLanguageAtom = atom(get => (userId: string): Language => {
  const selections = get(languageSelectionAtom)
  return selections.find(item => item.userId === userId)?.language || Language.EN
})

export const setUserLanguageAtom = atom(null, (get, set, selection: UserLanguage) => {
  const selections = get(languageSelectionAtom)

  const next = selections.some(item => item.userId === selection.userId)
    ? selections.map(item => (item.userId === selection.userId ? selection : item))
    : [...selections, selection]

  set(languageSelectionAtom, next)
})

export const getUserTimeFormatAtom = atom(get => (userId: string): string => {
  const selections = get(timeFormatSelectionAtom)
  return selections.find(item => item.userId === userId)?.timeFormat || 'dd.MM.yyyy'
})

export const setUserTimeFormatAtom = atom(null, (get, set, selection: UserTimeFormat) => {
  const selections = get(timeFormatSelectionAtom)

  const next = selections.some(item => item.userId === selection.userId)
    ? selections.map(item => (item.userId === selection.userId ? selection : item))
    : [...selections, selection]

  set(timeFormatSelectionAtom, next)
})

export const getCompanyCurrencyAtom = atom(get => (companyId: string): string => {
  const selections = get(currencySelectionAtom)
  return selections.find(item => item.companyId === companyId)?.currency || 'EUR'
})

export const setCompanyCurrencyAtom = atom(null, (get, set, selection: CompanyCurrency) => {
  const selections = get(currencySelectionAtom)

  const next = selections.some(item => item.companyId === selection.companyId)
    ? selections.map(item => (item.companyId === selection.companyId ? selection : item))
    : [...selections, selection]

  set(currencySelectionAtom, next)
})
